export const ALERT_SUCCESS = "ALERT_SUCCESS";
export const ALERT_FAILURE = "ALERT_FAILURE";
export const ALERT_CLEAR = "ALERT_CLEAR";
